import requestInstance from '~/utils/requestInstance';

type GetSplashScreenDataArgs = {
  projectUuid?: string;
  sceneUuid?: string;
};

export const getSplashScreenData = async <T>({
  projectUuid,
  sceneUuid,
}: GetSplashScreenDataArgs) => {
  try {
    if (!projectUuid) {
      return Promise.reject(`Missing projectUuid: ${projectUuid}`);
    }

    let urlPath = `/property_pickers/${projectUuid}/splash_screen`;

    if (sceneUuid) {
      urlPath += `?scene_uuid=${sceneUuid}`;
    }

    const response = requestInstance.get<T>(urlPath);

    return (await response).data;
  } catch (e) {
    return Promise.reject(e);
  }
};
